import { render, staticRenderFns } from "./NumberInfo.vue?vue&type=template&id=fca2c294&scoped=true&"
import script from "./NumberInfo.vue?vue&type=script&lang=js&"
export * from "./NumberInfo.vue?vue&type=script&lang=js&"
import style0 from "./NumberInfo.vue?vue&type=style&index=0&id=fca2c294&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fca2c294",
  null
  
)

export default component.exports